import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ClientParent } from '../models/client-parent';
import { siteSpecificData } from '../../../environments/site-specific-data';

const API_URL = siteSpecificData.apiUrlBase;

@Injectable()
export class ClientParentService {

  constructor(private http: HttpClient) { }

  getClientParent(clientParentRef: number): Observable<ClientParent> {
    const clientParentUrl = `${API_URL}clientParent`;
    return this
      .http
      .get<ClientParent>(clientParentUrl, { params: { clientParentRef: clientParentRef.toString() } })
      .pipe();
  }

  getAllClientParents(): Observable<ClientParent[]> {
    const clientParentsUrl = `${API_URL}clientParents`;
    return this
      .http
      .get<ClientParent[]>(clientParentsUrl)
      .pipe();
  }

}
